// extracted by mini-css-extract-plugin
export default {"nav--open":"Hamburger_nav--open__+Vgy5","is-active":"Hamburger_is-active__WXJRy"};